
import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Maria Gonzalez',
    location: 'Tampa, FL',
    rating: 5,
    date: 'October 2024',
    avatar: 'https://public.readdy.ai/ai/img_res/8476b90cfb3e11b3a69348ad61a6e43e.jpg',
    text: 'After Hurricane Idalia tore through our neighborhood, Cabadas Roofing was at our door within hours. They tarped the roof same day and had everything fully repaired within a week. Absolutely incredible response time and the quality of work is outstanding. Highly recommend!',
    service: 'Storm Damage Repair',
  },
  {
    id: 2,
    name: 'James Whitfield',
    location: 'Brandon, FL',
    rating: 5,
    date: 'September 2024',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20middle%20aged%20man%20portrait%20professional%20headshot%20warm%20natural%20lighting%20simple%20clean%20background&width=80&height=80&seq=avatar-002&orientation=squarish',
    text: 'I had a mysterious leak that two other roofers couldn\'t find. Cabadas came out for a free inspection and located it within 30 minutes using their detection equipment. Fixed it the same day. No more water stains on my ceiling. These guys are the real deal.',
    service: 'Leak Detection',
  },
  {
    id: 3,
    name: 'Sandra Patel',
    location: 'Clearwater, FL',
    rating: 5,
    date: 'August 2024',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20south%20asian%20woman%20portrait%20professional%20headshot%20warm%20natural%20lighting%20simple%20clean%20background&width=80&height=80&seq=avatar-003&orientation=squarish',
    text: 'Professional from start to finish. They showed up on time for the free inspection, gave me a fair and transparent quote, and completed the repair ahead of schedule. The crew was respectful of my property and cleaned up everything. 5 stars without hesitation.',
    service: 'Free Inspection & Repair',
  },
  {
    id: 4,
    name: 'Robert Castillo',
    location: 'St. Petersburg, FL',
    rating: 5,
    date: 'July 2024',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20latino%20man%20portrait%20professional%20headshot%20warm%20natural%20lighting%20simple%20clean%20background&width=80&height=80&seq=avatar-004&orientation=squarish',
    text: 'Used Cabadas for our commercial building after a major storm. They handled the insurance claim process with us, which was a huge relief. The repair was done fast and the roof has been perfect ever since. Great communication throughout the whole project.',
    service: 'Commercial Roof Repair',
  },
  {
    id: 5,
    name: 'Linda Thompson',
    location: 'Riverview, FL',
    rating: 5,
    date: 'June 2024',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20older%20woman%20portrait%20professional%20headshot%20warm%20natural%20lighting%20simple%20clean%20background&width=80&height=80&seq=avatar-005&orientation=squarish',
    text: 'I was nervous about getting my roof repaired but the team made the whole process easy. They explained everything clearly, the price was fair, and the work looks fantastic. My neighbors have already asked for their number. Truly a trustworthy company.',
    service: 'Residential Roof Repair',
  },
  {
    id: 6,
    name: 'Derek Monroe',
    location: 'Wesley Chapel, FL',
    rating: 5,
    date: 'May 2024',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20young%20black%20man%20portrait%20professional%20headshot%20warm%20natural%20lighting%20simple%20clean%20background&width=80&height=80&seq=avatar-006&orientation=squarish',
    text: 'Called at 9pm after a storm ripped off part of my roof. Someone answered immediately and they had a crew out by 7am the next morning. Emergency tarping done fast, full repair completed days later. Saved my home from serious water damage. Cannot thank them enough.',
    service: 'Emergency Storm Response',
  },
];

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <span key={star} className="w-4 h-4 flex items-center justify-center">
          <i
            className={`ri-star-fill text-base ${
              star <= rating ? 'text-amber-400' : 'text-gray-200'
            }`}
          ></i>
        </span>
      ))}
    </div>
  );
}

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const visibleCount = 3;

  const handlePrev = () => {
    setActiveIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) =>
      Math.min(testimonials.length - visibleCount, prev + 1)
    );
  };

  const visible = testimonials.slice(activeIndex, activeIndex + visibleCount);

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-orange-50 via-white to-amber-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-orange-100 text-orange-700 text-xs font-bold uppercase tracking-widest mb-4">
            Customer Reviews
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            What Florida Homeowners Say
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Hundreds of satisfied customers across Tampa Bay trust Cabadas Roofing LLC for quality repairs and honest service.
          </p>

          {/* Overall Rating Bar */}
          <div className="inline-flex items-center gap-4 mt-8 px-8 py-4 bg-white rounded-2xl shadow-md border border-orange-100">
            <div className="text-center">
              <div className="text-5xl font-extrabold text-gray-900 leading-none">5.0</div>
              <div className="flex justify-center mt-1 gap-0.5">
                {[1,2,3,4,5].map((s) => (
                  <span key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-base"></i>
                  </span>
                ))}
              </div>
              <div className="text-xs text-gray-400 mt-1">Average Rating</div>
            </div>
            <div className="w-px h-14 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-5xl font-extrabold text-gray-900 leading-none">200<span className="text-3xl">+</span></div>
              <div className="text-xs text-gray-400 mt-2">Verified Reviews</div>
            </div>
            <div className="w-px h-14 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-5xl font-extrabold text-gray-900 leading-none">98<span className="text-3xl">%</span></div>
              <div className="text-xs text-gray-400 mt-2">Would Recommend</div>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {visible.map((review, i) => (
            <div
              key={review.id}
              className={`bg-white rounded-2xl p-7 shadow-sm border border-gray-100 flex flex-col transition-all duration-500 hover:shadow-lg hover:-translate-y-1 ${
                i === 1 ? 'md:scale-105 md:shadow-lg border-orange-200' : ''
              }`}
            >
              {/* Quote icon */}
              <div className="w-9 h-9 flex items-center justify-center mb-4">
                <i className="ri-double-quotes-l text-3xl text-orange-200"></i>
              </div>

              {/* Stars */}
              <StarRating rating={review.rating} />

              {/* Text */}
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1">
                "{review.text}"
              </p>

              {/* Service tag */}
              <span className="inline-block mt-5 px-3 py-1 rounded-full bg-orange-50 text-orange-600 text-xs font-semibold">
                {review.service}
              </span>

              {/* Divider */}
              <div className="border-t border-gray-100 mt-5 pt-5 flex items-center gap-3">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-11 h-11 rounded-full object-cover object-top flex-shrink-0"
                />
                <div>
                  <div className="text-sm font-bold text-gray-900">{review.name}</div>
                  <div className="text-xs text-gray-400 flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-map-pin-2-line text-xs text-orange-400"></i>
                    </span>
                    {review.location} · {review.date}
                  </div>
                </div>
                <div className="ml-auto w-6 h-6 flex items-center justify-center">
                  <i className="ri-verified-badge-fill text-lg text-green-500"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={handlePrev}
            disabled={activeIndex === 0}
            className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gray-200 text-gray-500 hover:border-orange-500 hover:text-orange-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setActiveIndex(Math.min(i, testimonials.length - visibleCount))}
              className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                i >= activeIndex && i < activeIndex + visibleCount
                  ? 'bg-orange-500 w-6'
                  : 'bg-gray-300'
              }`}
            />
          ))}

          <button
            onClick={handleNext}
            disabled={activeIndex >= testimonials.length - visibleCount}
            className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-gray-200 text-gray-500 hover:border-orange-500 hover:text-orange-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        {/* Google CTA */}
        <div className="text-center mt-10">
          <p className="text-sm text-gray-400">
            Read more reviews on{' '}
            <a
              href="https://www.google.com/search?q=Cabadas+Roofing+LLC"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-orange-600 font-semibold hover:underline cursor-pointer"
            >
              Google
            </a>{' '}
            &amp;{' '}
            <a
              href="#"
              rel="nofollow"
              className="text-orange-600 font-semibold hover:underline cursor-pointer"
            >
              Facebook
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
